import React, { useCallback, useEffect, useRef, useState } from 'react'
import './ShiftManagment.css'
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import images1 from '../../assets/images1.jfif'
import { Col, Row, Radio, Button, Dropdown, Menu, Checkbox } from 'antd'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { AlignLeftOutlined, FilterOutlined, LeftOutlined, RightOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { BASE_URL, FetchAttendanceCalendar, FetchAttendanceTodayView, FetchDepartment, FetchDesignation, FetchLocation, FetchShifts, ShiftLogs, structuredStaffListing } from '../../utils/constant';
import moment from 'moment';
import dayjs from 'dayjs';
import ShiftPlanModel from './ShiftPlanModel';
import Spinner from "../../common/Spinner"; 
import { FaAngleDown } from "react-icons/fa6";
import SearchIcon from "../../assets/icons/search-icon.svg";

function ShiftManagment() {
  const designationState = useSelector((state) => state.designation.designation);
  const departmentState = useSelector((state) => state.department.department);
  const ShiftState = useSelector((state) => state.shift.shift);
  const locationState = useSelector((state) => state.location.location);
  const gridRef = useRef(null);
  const searchRef = useRef([]);
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const userInfo = useSelector((state) => state.signUp.signUpDetails);

  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [shiftPlanVisible, setShiftPlanVisible] = useState(false);
  const [shiftPlanData, setShiftPlanData] = useState();
  const [staffId, setStaffId] = useState('');
  const [selecetdStaffData, setSelecetdStaffData] = useState('');
  const [events, setEvents] = useState([]);
  const [staffShiftData, setStaffShiftData] = useState([])
  const [staffShiftIdsData, setStaffShiftIdsData] = useState([])

  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [selectedYear, setSelectedYear] = useState(moment(new Date()).format("YYYY"));
  const [selectedMonth, setSelectedMonth] = useState(moment(new Date()).format("MM"));
  const [showSelectedDate, setshowSelectedDate] = useState(moment(new Date()).subtract(1, 'day').format("YYYY-MM-DD"));
  const [staffData, setStaffData] = useState(null);
  const [departments, setDepartments] = useState(departmentState);
  const [designations, setDesignations] = useState(designationState);
  const [shift, setShift] = useState(ShiftState);
  const [fullShiftData, setFullShiftData] = useState([]);
  const [location, setLocation] = useState(locationState);
  const [departmentsSelected, setDepartmentsSelected] = useState();
  const [designationsSelected, setDesignationsSelected] = useState();
  const [shiftSelected, setShiftSelected] = useState();
  const [locationSelected, setLocationSelected] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const keys = departmentState.map((item, index) => (index === 0 || index === 1) ? item.key : null).filter(key => key !== null);

  const [selectedDepartment, setSelectedDepartment] = useState(keys);
  const [selectedDesignation, setSelectedDesignation] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedShift, setSelectedShift] = useState([]);
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
  const staffIdsRef = useRef([]);
  const toggleSearchVisibility = () => {
    setIsSearchVisible((prevState) => !prevState);
  };
  const onGridReady = (params) => {
    gridRef.current = params.api;
params.api.sizeColumnsToFit();
};
const showImgForm = (item) => {
  // setShowImg(item)
  setShiftPlanVisible(true);
};
const hideShiftPlanForm = (item) => {
  getStaffMonthList()
  setShiftPlanVisible(false);
};

  const onSelectionChanged = () => {
    const selectedNodes = gridRef.current.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node?.data?.item);
    staffIdsRef.current = selectedData;
  };

  const onFilterTextBoxChanged = useCallback((event) => {
    const filterValue = event.target.value;
    searchRef.current.forEach((grid, index) => {
        if (grid?.api) {
            grid?.api.setQuickFilter(filterValue);
        }
    });
}, []);

  const handleMenuClick = ({ key }) => {
    // Toggle the selected item
    const updatedItems = [...selectedItems];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedItems(updatedItems);
  };
  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="isStaffLessTime">
        <Checkbox checked={selectedItems.includes('isStaffLessTime')}>Less Time</Checkbox>
      </Menu.Item>
      <Menu.Item key="isAbsent">
        <Checkbox checked={selectedItems.includes('isAbsent')}>Absent</Checkbox>
      </Menu.Item>
      <Menu.Item key="isStaffHalfDay">
        <Checkbox checked={selectedItems.includes('isStaffHalfDay')}>Half Day</Checkbox>
      </Menu.Item>
      <Menu.Item key="isWrongLocation">
        <Checkbox checked={selectedItems.includes('isWrongLocation')}>Wrong Location</Checkbox>
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    // getDepartmentList();
    // getDesignationList();
    getShiftList();
    // getLocationList();
  }, []);
  const getDesignationList = async () =>{
    const token = localStorage.getItem('authToken');
  
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({isDeleted:false}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeDesignation = data.data.filter(item => item.isActive);
            const newArray = activeDesignation.map((item) => ({
                value: item.designationName,
                key: item.designationId
              }));
             setDesignations(newArray)
          
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  }
  const getDepartmentList = async () =>{
    const token = localStorage.getItem('authToken');
  
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({isDeleted:false}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeDepartment = data.data.filter(item => item.isActive);
            const newArray = activeDepartment.map((item) => ({
                value: item.departmentName,
                key: item.departmentId
              }));
              if(newArray.length > 0){

                  setDepartmentsSelected(newArray[0].key)
                  // const keys = newArray.map(item => item.key);
                  // setSelectedDepartment(keys);
                  const keys = newArray.map((item, index) => (index === 0 || index === 1) ? item.key : null).filter(key => key !== null);
                  setSelectedDepartment(keys);
                }

                
             setDepartments(newArray)
             getStaffTodayList()
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  }
  const getShiftList = async () =>{
    const token = localStorage.getItem('authToken');
  
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchShifts}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeShift = data.data.filter(item => item.isActive);
            setFullShiftData(activeShift)
            const newArray = activeShift.map((item) => ({
                value: item.shiftFullName,
                key: item.shiftId
              }));
             setShift(newArray)
          
          } else {
            const data = await response.json();
            console.log('shifterr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  }
  const getLocationList = async () =>{
    const token = localStorage.getItem('authToken');
  
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchLocation}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({isDeleted:false}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeLocation = data.data.filter(item => item.isActive);
            const newArray = activeLocation.map((item) => ({
                value: item.locationName1,
                key: item.locationId
              }));
             setLocation(newArray)
          
          } else {
            const data = await response.json();
            console.log('locationerr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  }
  const handleDesigMenuClick = ({key}) => {
    // console.log('Clicked on:', e);
    // setDesignationsSelected(e.key)

    const updatedItems = [...selectedDesignation];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedDesignation(updatedItems);
  }
  const handleShiftMenuClick = ({key}) => {
    // console.log('Clicked on:', e);
    // setShiftSelected(e.key)

    const updatedItems = [...selectedShift];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedShift(updatedItems);
  }
  const handleLocationMenuClick = ({key}) => {
    // console.log('Clicked on:', e);
    // setLocationSelected(e.key);

    const updatedItems = [...selectedLocation];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedLocation(updatedItems);
  }
  const handleDeptMenuClick = ({key}) => {
    // console.log('Clicked on:', e);
    // setDepartmentsSelected(e.key);

    const updatedItems = [...selectedDepartment];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedDepartment(updatedItems);
  };
  const [openDepartment, setOpenDepartment] = useState(false);
      const handleDepartmentOpenChange = (nextOpen, info) => {
        setOpenDepartment(nextOpen);
      };
      const [openDesignation, setOpenDesignation] = useState(false);
      const handleDesignationOpenChange = (nextOpen, info) => {
        setOpenDesignation(nextOpen);
      };
     
      const [openShift, setOpenShift] = useState(false);
      const handleShiftOpenChange = (nextOpen, info) => {
        setOpenShift(nextOpen);
      };
      const [open, setOpen] = useState(false);
      const handleOpenChange = (nextOpen, info) => {
          setOpen(nextOpen);
      };
  const dept = (
    // <Menu onClick={handleDeptMenuClick}>
      
    //     {departments?.map((department) => (
    //       <Menu.Item key={department.key}>{department.value}</Menu.Item>
    //     ))}
    // </Menu>
    <Menu onClick={handleDeptMenuClick}>
    
    {departments?.map((department) => (
      <Menu.Item className='checktext' key={department.key}>
        <Checkbox className='mr-1' checked={selectedDepartment.includes(department.key)}/>{department.value}
        
        </Menu.Item>
    ))}
</Menu>
  );
  const desigMenu = (
    // <Menu onClick={handleDesigMenuClick}>
      
    //     {designations.map((designation) => (
    //       <Menu.Item key={designation.key}>{designation.value}</Menu.Item>
    //     ))}
    // </Menu>
    <Menu onClick={handleDesigMenuClick}>
    
    {designations.map((designation) => (
      <Menu.Item className='checktext' key={designation.key}>
        <Checkbox className='mr-1' checked={selectedDesignation.includes(designation.key)}/>{designation.value}
        
        </Menu.Item>
    ))}
    </Menu>
  );
  const shiftMenu = (
    // <Menu onClick={handleShiftMenuClick}>
      
    //     {shift.map((shift) => (
    //       <Menu.Item key={shift.key}>{shift.value}</Menu.Item>
    //     ))}
    // </Menu>
    <Menu onClick={handleShiftMenuClick}>
    
    {shift.map((shift) => (
      <Menu.Item className='checktext' key={shift.key}>
        <Checkbox className='mr-1' checked={selectedShift.includes(shift.key)}/>{shift.value}
        
        </Menu.Item>
    ))}
    </Menu>
  );
  const locationMenu = (
    // <Menu onClick={handleLocationMenuClick}>
      
    //     {location.map((location) => (
    //       <Menu.Item key={location.key}>{location.value}</Menu.Item>
    //     ))}
    // </Menu>
    <Menu onClick={handleLocationMenuClick}>
    
    {location.map((location) => (
      <Menu.Item className='checktext' key={location.key}>
        <Checkbox className='mr-1' checked={selectedLocation.includes(location.key)}/>{location.value}
        
        </Menu.Item>
    ))}
    </Menu>
  );

  const rowData = staffData?.staffs[0]?.staffDetails?.map((item, index) => {
    const shouldInclude = selectedItems.every(prop => {
        if (prop === "isAbsent") {
          return item?.[prop] === true;
        } else {
          return item?.attendanceDetail[0]?.[prop] === true;
        }
      });       
    if (shouldInclude) {

      return {
        key: index,
        item: item,
        profile: item?.firstName
      };
    }
    return null; // Skip this item if isStaffHalfDay is false or undefined
  }).filter(Boolean); 

  const getColumnDefs = () => {
    return [
     
      {
        headerName: 'Profile',
        field:'profile',
        
        cellRenderer: (params) => {
            return(
                <>
                <div className='profile'>
                  <div className='flex items-center gap-2 py-1'>
                    <div className='w-8 h-8 overflow-hidden rounded-full'>
                      <img
                        className='w-full h-full object-cover'
                        src={params.data?.item?.faceRegisterUrl || params.data?.item?.logo}
                        alt=''
                      />
                    </div>
                    <div className='flex-1'>
                      <p className='text-sm font-medium'>
                        {capitalizeFirstLetter(params.data.item?.firstName)} {capitalizeFirstLetter(params.data.item?.lastName)}
                        {/* {params.data.item?.isAbsent == false && params.data.item?.notInYet == true ? 
                        <span></span> :
                        params.data.item?.isAbsent == true  ? 
                         <span className='a ml-1 mr-1'>A</span>
                        : params.data.item?.isAbsent == false &&
                         params.data.item?.attendanceDetail.length > 0 ? */}
                        
                         {params.data.item?.isAbsent == true ?
                     <span className='a ml-1 mr-1'>A</span>
                     : params.data.item?.isAbsent == false &&  params.data.item?.notInYet == true ? 
                     <span></span> 
                     : params.data.item?.isAbsent == false && params.data.item?.attendanceDetail.length > 0 && params.data.item?.attendanceDetail[0]?.isWeeklyOff == true && params.data.item?.attendanceDetail[0]?.isStaffOut == false ?
                     <span className='Ot ml-1 mr-1'>WO</span>
                     : params.data.item?.isAbsent == false && params.data.item?.attendanceDetail.length > 0 && params.data.item?.attendanceDetail[0]?.isWeeklyOff == false && params.data.item?.attendanceDetail[0]?.isStaffOut == false ?
                     <span className='a ml-1 mr-1'>A</span>
                     : params.data.item?.isAbsent == false && params.data.item?.attendanceDetail.length > 0 && params.data.item?.attendanceDetail[0]?.isWeeklyOff == true && params.data.item?.attendanceDetail[0]?.isStaffOut == true ?
                     <span className='p ml-1 mr-1'>P</span>
                     : params.data.item?.isAbsent == false && params.data.item?.attendanceDetail.length > 0 && params.data.item?.attendanceDetail[0]?.isWeeklyOff == false && params.data.item?.attendanceDetail[0]?.isStaffOut == true ?
                         (
                          <>
                          <span className='p ml-1 mr-1'>P</span> 
                     {/* <span className='p ml-1 mr-1'>M</span>  */}
                          {params.data.item?.attendanceDetail[0].isStaffHalfDay && <span className='h ml-1 mr-1'>HD</span>}
                          {params.data.item?.attendanceDetail[0].isStaffOverTime && <span className='Ot ml-1 mr-1'>OT</span>}
                          {params.data.item?.attendanceDetail[0].isStaffLessTime && <span className='Ot ml-1 mr-1'>LT</span>}
                          {params.data.item?.attendanceDetail[0].isStaffEarly || params.data.item?.attendanceDetail[0].isStaffLate
                             ? <span className='Ot ml-1 mr-1'>WT</span>
                             : ''
                           }
                          {params.data.item?.attendanceDetail[0].isWrongLocation && <span className='Ot ml-1 mr-1'>WL</span>}
                          {params.data.item?.attendanceDetail[0].isStaffNotClockedOut && <span className='Ot ml-1 mr-1'>CO</span>}
                           </>
                         ) : ''
                        }
                        
                       
                         </p>
                      <p className='text-xs'>{capitalizeFirstLetter(params.data.item?.designation.designationName)} | {capitalizeFirstLetter(params.data?.department)}</p>
                    </div>
                  </div>
                </div>
                </>
            )
            },
      },
    ];
  };

  const getDepartmentRowData = (department) => {
    if (selectedItems.length === 0) {
      return (
        department.staffDetails?.map((item, index) => ({
          key: index,
          item: item,
          profile: item?.firstName,
          department: department?.departmentName
        })) || []
      );
    }
    console.log('department->',department.staffDetails);
    return (
      department.staffDetails?.map((item, index) => {
        const shouldInclude = selectedItems.some(prop => {
          if (prop === "isAbsent") {
            return item?.[prop] === true;
          } else {
            return item?.attendanceDetail[0]?.[prop] === true;
          }
        });
  
        if (shouldInclude) {
          return {
            key: index,
            item: item,
            profile: item?.firstName,
            department: department?.departmentName
          };
        }
        return null; // Skip this item if conditions are not met
      }).filter(Boolean) || []
    )
  };

  useEffect(() => {
    getStaffTodayList();
  }, [departmentsSelected,designationsSelected,locationSelected,shiftSelected,selectedDepartment,selectedDesignation,selectedLocation,selectedShift]);

  const getStaffTodayList = async () =>{
    const token = localStorage.getItem('authToken');
    setIsLoadingSpinner(true)
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${structuredStaffListing}`, {
        method: "POST",
         headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `${token}`,
                  
                },
        body: JSON.stringify({
          "isActive": true,
          ...(selectedDepartment && selectedDepartment.length > 0 && { department : selectedDepartment }),
          ...(selectedDesignation && selectedDesignation.length > 0 && { designation : selectedDesignation }),
          ...(selectedLocation && selectedLocation.length > 0 && { mainSite : selectedLocation }),
          ...(selectedShift && selectedShift.length > 0 && { shift : selectedShift }),

        }),
      });
      
      if (response.ok) {
        const data = await response.json();
        setStaffData(data?.data)
        setIsLoadingSpinner(false)
        
      } else {
        const data = await response.json();
        console.log('stafTodayerr',data)
        setIsLoadingSpinner(false)
        // toast.error(data.errorMessage, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        
      }
    };
   
    await fetchData();
   
  }
  const handleRowClick = (event) => {
    const rowData = event.data.item; // Access the rowData object
    // Now you can perform actions with the rowData object
    setStaffId(rowData?._id)
    setSelecetdStaffData(rowData)
    // You can use the rowData object as needed
  //   const selectedRow = event.node.rowIndex;
  // const rowElements = document.querySelectorAll('.ag-row');
  
  // // Remove the class from all rows
  // rowElements.forEach((row) => {
  //   row.classList.remove('row-clicked');
  // });
  // Add the class to the clicked row
  // rowElements[selectedRow].classList.add('row-clicked');
};
const getRowStyle = (params) => {
 
  if (params.data.item._id === staffId) {
      return { background: 'lightblue' }; // Set the background color for the selected row
  }
  return null;
};


  useEffect(() => {
    if(staffId){

    
      if(staffShiftData && staffShiftData?.logs?.length > 0){
        
        const mappedEvents = staffShiftData?.logs[(selectedMonth + 8) % 12]?.map(item => {
        const shiftData = staffShiftData?.shifts[item.shiftId];
        const locationData = [];

        item?.mainSite?.forEach(site => {
          const data = staffShiftData?.mainSites[site];
          if (data) {
            locationData.push(data);
          }
        });        // const locationData = staffShiftData?.mainSites[item.mainSite[0]];
        return {
          title: 'Your Event Title',
          item: item,
          selecetdStaffData:selecetdStaffData,
          shiftData: shiftData,
          locationData: locationData,
          start: new Date(item?.logDate),
          end: new Date(item?.logDate), // Set the end time as the same date for simplicity
        };
      });
  setEvents(mappedEvents)
}
}
  }, [selectedMonth, staffShiftData,selectedYear,staffId]);
  
  useEffect(() => {
    // getStaffDayList();
    if(staffId){

      getStaffMonthList()
    }
  }, [selectedYear,staffId]);

  const getStaffMonthList = async () =>{
    const token = localStorage.getItem('authToken');
    setIsLoadingSpinner(true)

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${ShiftLogs}`, {
        method: "POST",
         headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `${token}`,
                  
                },
        body: JSON.stringify({
            "staffId" : staffId,
            "year" : selectedYear 
        }),
      });
      
      if (response.ok) {
        const data = await response.json();
        
        setStaffShiftData(data?.data)
       
                    // if (!data?.data?.shifts || typeof data?.data?.shifts !== 'object') {
                    //   console.error('Invalid shift data');
                    //   return;
                    // }
                    
                    // const colorCombinations = [
                    //   { bg: 'LemonChiffon', bgCode: '#FFFACD', txt: 'DarkSlateGray', txtCode: '#2F4F4F' },
                    //   { bg: 'LightCoral', bgCode: '#F08080', txt: 'DarkRed', txtCode: '#8B0000' },
                    //   { bg: 'Azure', bgCode: '#F0FFFF', txt: 'MidnightBlue', txtCode: '#191970' },
                    //   { bg: 'LightGoldenRodYellow', bgCode: '#FAFAD2', txt: 'DarkOliveGreen', txtCode: '#556B2F' }
                    // ];
                    
                    // // Iterate over each shift ID and assign color combinations
                    // Object.keys(data?.data?.shifts).forEach((shiftId, index) => {
                    //   const colorIndex = index % colorCombinations.length; // Select color combination cyclically
                      
                    //   const colorCombination = colorCombinations[colorIndex];
                    //   const shiftData = data?.data?.shifts[shiftId];
                      
                    //   // Assign color combination to the shift data
                    //   shiftData.color = {
                    //     bg: colorCombination.bg,
                    //     bgCode: colorCombination.bgCode,
                    //     txt: colorCombination.txt,
                    //     txtCode: colorCombination.txtCode
                    //   };
                    // });
                    // setStaffShiftIdsData(data?.data?.shifts)
                    console.log('ShiftLogs', data?.data?.shifts);
                    setIsLoadingSpinner(false)
          
      } else {
        const data = await response.json();
        setIsLoadingSpinner(false)

        console.log('stafTodayerr',data)
        // toast.error(data.errorMessage, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        
      }
    };
   
    await fetchData();
   
  }

  // const getStaffDayList = async () =>{
  //   const token = localStorage.getItem('authToken');
  
  //   const fetchData = async () => {
  //     const response = await fetch(`${BASE_URL}/${FetchAttendanceCalendar}`, {
  //       method: "POST",
  //        headers: {
  //                 'Content-Type': 'application/json',
  //                 'Authorization': `${token}`,
                  
  //               },
  //       body: JSON.stringify({
  //           "staffId" : staffId,
  //           "month" : 1,
  //           "year" : 2024
  //       }),
  //     });
      
  //     if (response.ok) {
  //       const data = await response.json();
  //       // setStaffCalendarData(data?.data)
  //       console.log('StaffCalendar',data)
  //       const mappedEvents = data?.data?.staffs?.map(item => ({
  //         title: 'Your Event Title',
  //         item:item,
  //         start: item?.attendanceDate,
  //         end: item?.attendanceDate, // Set the end time as the same date for simplicity
  //         checkInTime: item?.checkInTime ? formatTimeWithAMPM(item?.checkInTime) : '--' ,
  //         checkOutTime: item?.checkOutTime ? formatTimeWithAMPM(item?.checkOutTime) : '--' ,
  //         totalWorkingHr: item?.totalWorkingHr ? formatTime(item?.totalWorkingHr) : '--' ,
  //         location : Object.keys(item?.checkInLocationDetail).length === 0 ? '--' : item?.checkInLocationDetail?.locationName2,
  //         attendance : item?.isAbsent || 
  //                      item?.isAbsent == false && item?.isWeeklyOff == false && item?.isStaffOut == false  ? <span className='a ml-auto mr-1'>A</span>
  //                      : item?.isAbsent == false && item?.isWeeklyOff == true  && item?.isStaffOut == true  ? <span className='present ml-auto mr-1'>P</span>
  //                      : item?.isAbsent == false && item?.isWeeklyOff == true  && item?.isStaffOut == false ? <span className='Ot ml-auto mr-1'>WO</span>
  //                      : item?.isStaffHalfDay ? <span className='Ot ml-auto mr-1'>HD </span>
  //                      : <span className='present ml-auto mr-1' >P </span>
  //       }));
  
  //       // setEvents(mappedEvents)
  //     } else {
  //       const data = await response.json();
  //       console.log('stafTodayerr',data)
  //       // toast.error(data.errorMessage, {
  //       //   position: toast.POSITION.TOP_RIGHT,
  //       // });
        
  //     }
  //   };
   
  //   await fetchData();
   
  // }

  function formatTime(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.round((milliseconds % 3600000) / 60000);
  
    if (hours > 0) {
      return `${hours}:${minutes < 10 ? '0' : ''}${minutes} H`;
    } else {
      return `${minutes} m`;
    }
  }
  function formatTimeWithAMPM(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.round((milliseconds % 3600000) / 60000);
  
    const formattedHours = hours % 12 || 12;
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
  }

  const initialDate = new Date(2024, 1 - 1, 1);


  const handleDateClick = (arg) => {
    // Retrieve the event data associated with the clicked date
    if(new Date(arg.event.extendedProps.item.logDate) > new Date()){

      const eventData = arg.date;
      
      setShiftPlanData(arg.event.extendedProps)
      setShiftPlanVisible(true);
    }

  };

  const handleDatesRender = (arg) => {
    if(arg.view.currentStart.getMonth() + 1 < 4){

      setSelectedYear(arg.view.currentStart.getFullYear() - 1)
    }else{
      setSelectedYear(arg.view.currentStart.getFullYear() )
      
    }
    setSelectedMonth(arg.view.currentStart.getMonth() + 1)
};
  const items = [
    {
      key: '1',
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
          1st menu item
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.aliyun.com">
          2nd menu item
        </a>
      ),
    },
    {
      key: '3',
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com">
          3rd menu item
        </a>
      ),
    },
  ];
  const [size, setSize] = useState("all");
  const handleSizeChange = (e) => {
    setSize(e.target.value);
  };
  const [randNumber, setRandNumber] = useState(0);
  useEffect(() => {
    setRandNumber(Math.random());
  }, []);
  const dayCellContent = (arg) => {
    const isSunday = arg.date.getDay() === 0;
    const isCurrentDay = arg.date.getDate() === new Date().getDate();

    return (
      <span
        style={{
          color: "black"
        }}
      >
        {arg.dayNumberText}
      </span>
    );
  };

  const calendarEvents = [{
    allDay: false,
    id: 1,
    title: "W/O",
    start: new Date("2023-12-03"),
    end: new Date("2023-12-03"),
    description: null,
  },{
    allDay: false,
    id: 1,
    title: "GEN-A",
    start: new Date(),
    end: new Date(),
    description: <><p style={{fontSize:'10px'}}>09:00 AM - 06:00 PM</p></>,
    company:<> <span className='keshar'>Keshar Towars</span></>,
  }];
const [ dynamicStyles ,setDynamicStyles] = useState([]);
  useEffect(() => {
    setDynamicStyles(staffShiftData?.logs?.map(logArray => {
      const idColors = {};
      return logArray.map(item => {
        if (item?.isWeeklyOff === true) {
            return `
                .fc-day[data-date="${moment(item?.logDate).format("YYYY-MM-DD")}"] .fc-daygrid-day-frame {
                  background: #DDEDF7 !important;
                }
                `;
              }
              else if(item?.isWeeklyOff === false && staffShiftData?.shifts[item?.shiftId]) {
                console.log('staffShiftIdsData[item?.shiftId].bgCode',staffShiftData?.shifts[item?.shiftId]?.color?.bgCode)
                const shiftColor = staffShiftData?.shifts[item?.shiftId]?.color?.bgCode;
                const shiftTextColor = staffShiftData?.shifts[item?.shiftId]?.color?.txtCode;
                return `
                .fc-day[data-date="${moment(item?.logDate).format("YYYY-MM-DD")}"] .fc-daygrid-day-frame {
                  background: ${shiftColor} !important;
                  }
                .fc-day[data-date="${moment(item?.logDate).format("YYYY-MM-DD")}"] .fc-daygrid-day-frame .fc-h-event .fc-event-main{
                  color: ${shiftTextColor} !important;
                  }
                `;
              }
              return '';
            }).join('');
          }).join(''));
        }, [staffShiftData]);

        function getRandomColor() {
          const letters = '0123456789ABCDEF';
          let color = '#';
          for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
          }
          return color;
        }
  // const columns = [
  //   {
  //     headerName: 'Designation Name',
  //     field: 'designation',
  //   },
  //   {
  //     headerName: 'Name (short)',
  //     field: 'name',
  //   },
  //   {
  //     headerName: 'Description',
  //     field: 'description',
  //   },
  //   // {
  //   //   headerName: 'Earned Leave Enabled',
  //   //   field: 'earned',
  //   // },
  //   // {
  //   //   headerName: 'OT Enabled',
  //   //   field: 'ot',
  //   // },
  //   // {
  //   //   headerName: 'Active User',
  //   //   field: 'active',
  //   // },
  //   {
  //     headerName: 'Action',
  //     field: 'action',
  //     cellRenderer: (params) => {
  //       return (
  //           <>
  //                    <div className='flex'>
  //                        <BsPencil className='shi-pen' onClick={() => handleEdit(params?.data?.item)}/>
  //                    </div>
  //                </>
  //       );
  //     },
  //   },
  // ];
  // const data = designationData.map((item, index) => ({

  //   key: index,
  //   item:item,
  //   designation: capitalizeFirstLetter(item.designationName),
  //   name: capitalizeFirstLetter(item.designationShortName),
  //   description: capitalizeFirstLetter(item.designationDescription),
    

  //   actions: (
  //     <div className="flex" style={{ justifyContent: 'center', display: 'flex' }}>
  //       <BsPencil  
  //         style={{
  //           border: '1px solid #D7E7F8',
  //           padding: '3px',
  //           backgroundColor: '#D7E7F8',
  //           borderRadius: '50%',
  //           fontSize: '17px',
  //         }}
  //       />
  //       <StopOutlined 
  //         style={{
  //           border: '1px solid #D7E7F8',
  //           padding: '3px',
  //           backgroundColor: '#F5E7E9',
  //           borderRadius: '50%',
  //           fontSize: '10px',
  //           color: '#DC3545',
  //           marginLeft: '5px',
  //         }}
  //       />
  //     </div>
  //   ),
  // }));
  return (
    <div>
      {isLoadingSpinner && <Spinner/> }

      <Row className='mt-2'>
        {/* <Col lg={12} md={24} sm={24} xs={24}>
          <div className='flex alertstab bg-default mt-2'>
            <Radio.Group value={size} onChange={handleSizeChange} className='flex ml-2'>
              <Radio.Button value="all">All</Radio.Button>
              <Radio.Button value="stream" ><p>STREAM Users</p></Radio.Button>
              <Radio.Button value="nonstream" >Non STREAM users</Radio.Button>
            </Radio.Group>
          </div>
        </Col> */}
        {/* <Col lg={12} md={24} sm={24} xs={24}>
          <div className='flex ma-fil mt-2'>
            <p style={{ alignItems: "center", display: "flex", marginRight: "10px", fontSize: '10px', fontWeight: 'bold' }}>Filter</p>
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Button className='man-btn mr-2'>Department</Button>
            </Dropdown>
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Button className='man-btn mr-2'>Designation</Button>
            </Dropdown>
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Button className='man-btn mr-2'>Shift</Button>
            </Dropdown>
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Button className='man-btn mr-2'>Late</Button>
            </Dropdown>
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Button className='man-btn mr-2'>Contractor</Button>
            </Dropdown>
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Button className='man-btn mr-2'>Location</Button>
            </Dropdown>
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
            >
              <Button className='man-btn'>More Filter</Button>
            </Dropdown>
          </div>
        </Col> */}
         <Col className='bg-[#E9F1FD] rounded-[9px] min-h-[52px] flex items-center'>
                        <div className='flex filter flex-wrap items-center gap-2'>
                            <p className='text-sm font-sbold !ml-4 !mr-3'>Filter</p>
                            <Dropdown
                                overlay={dept} trigger={['click']}
                                placement="bottom"
                                onOpenChange={handleDepartmentOpenChange}
                                open={openDepartment}
                            >
                                <Button className='bg-[#BAD2F8] !border-none !leading-none !pr-2 !outline-none'>
                                  <span className='!text-black text-sm font-sbold leading-none !flex items-center'>Department <FaAngleDown className='ml-1 text-xs' /></span>
                                </Button>
                            </Dropdown>
                          
                            <Dropdown
                                overlay={desigMenu} trigger={['click']}
                                placement="bottom"
                                onOpenChange={handleDesignationOpenChange}
                                open={openDesignation}
                                >
                                <Button className='bg-[#BAD2F8] !border-none !leading-none !pr-2 !outline-none'>
                                  <span className='!text-black text-sm font-sbold leading-none !flex items-center'>Designation <FaAngleDown className='ml-1 text-xs' /></span>
                                </Button>
                            </Dropdown>
                            <Dropdown
                                overlay={shiftMenu} trigger={['click']}
                                onOpenChange={handleShiftOpenChange}
                                open={openShift}
                                placement="bottom"
                                >
                                <Button className='bg-[#BAD2F8] !border-none !leading-none !pr-2 !outline-none'>
                                  <span className='!text-black text-sm font-sbold leading-none !flex items-center'>Shift <FaAngleDown className='ml-1 text-xs' /></span>
                                </Button>
                            </Dropdown>

                            {/* <Dropdown overlay={menu} trigger={['click']}>
                             <Button  className='btn filterBtn' onClick={(e) => e.preventDefault()}>
                             Attendance Error
                             </Button>
                           </Dropdown> */}
                            <Dropdown
                                    overlay={locationMenu} trigger={['click']}
                                    onOpenChange={handleOpenChange}
                                    open={open}
                                placement="bottom"
                            >
                                <Button className='bg-[#BAD2F8] !border-none !leading-none !pr-2 !outline-none'>
                                  <span className='!text-black text-sm font-sbold leading-none !flex items-center'>Location <FaAngleDown className='ml-1 text-xs' /></span>
                                </Button>
                            </Dropdown>
                            
                        </div>
                    </Col>
      </Row>

     
        <div className='mt-3 flex'>
            <div className='flex-1 overflow-x-auto flex-nowrap flex gap-3 mr-5 slimScroll pb-2'>
                    {staffData?.shifts?.map((item, index) => (
                        <div key={index}>
                            <div>
                                <p className='text-[#0F94AF] text-xs uppercase font-sbold'>{capitalizeFirstLetter(item?.shiftFullName)}</p>
                            </div>
                            <div style={{ backgroundColor: item?.color?.bgCode, color: item?.color?.txtCode }} className={`flex bg-[#E9F1FD] px-3 py-2 h-12 rounded-[13px] items-center`}>
                                <p className={`text-[23px] font-bold mr-2`}>{item?.activeStaff}</p>
                                <span className='text-xs'>People</span>
                                <span className='border-l mx-2 border-black'>&nbsp;</span>
                                <p className='text-sm font-sbold whitespace-nowrap'>{formatTimeWithAMPM(item?.shiftStartTime)} - {formatTimeWithAMPM(item?.shiftEndTime)}</p>
                            </div>
                        </div>
                    ))}
            </div>
            <div className='d-flex align-items-center justify-content-end'>
                {/* <UploadOutlined className='mang-upload' />
                <Dropdown
                    menu={{
                        items,
                    }}
                    placement="bottom"
                >
                    <Button className='mang-view'>View by</Button>
                </Dropdown> */}
                {isSearchVisible && (
                <input
                        type="text"
                        id="filter-text-box"
                        className='border-bottom h-[36.56px] !border-[#B7D0F7] outline-none'
                        placeholder="Search..."
                        // onInput={onFilterTextBoxChanged}
                        onChange={onFilterTextBoxChanged}

                      />
                )}
                <img
                  src={SearchIcon}
                  onClick={toggleSearchVisibility}
                  className="cursor-pointer"
                />
                {/* <SearchOutlined className='mang-search' /> */}
                {/* <AlignLeftOutlined className='mang-outline' />
                <FilterOutlined className='mang-filter' /> */}
            </div>
        </div>

      {/* <div className='flex justify-between mt-4'>
        <p className='man-sal-tit'>Sales Department</p>
        <div className='flex'>
          <LeftOutlined className='man-left' />
          <p className='mang-date'>July 2023</p>
          <RightOutlined className='man-left mr-5' />
        </div>
      </div> */}

      <Row className='align-items-start mt-4'>
        <Col lg={4} style={{ height: '700px', overflowY: 'auto', }} className='slimScroll'>
        <div className='ag-theme-alpine'>
          {staffData?.staffs.map((department, index) => (
            // selectedDepartment.includes(department.departmentId) && (
            <div key={index} className="department-table mb-3">
              <div className='text-[#0F94AF] text-[13px] font-medium mb-2'>{capitalizeFirstLetter(department.departmentName)} Department</div>
              <AgGridReact
                className='fw600 mr-2 [&_.ag-header]:hidden [&_.ag-pinned-left-cols-container]:!hidden [&_.ag-paging-page-summary-panel]:flex-1 [&_.ag-paging-page-summary-panel]:!mx-0 [&_.ag-paging-row-summary-panel]:!hidden [&_.ag-root-wrapper]:border-none [&_.ag-center-cols-viewport]:!min-h-[initial] [&_.ag-center-cols-viewport]:!h-[initial] [&_.ag-center-cols-container]:!w-full [&_.ag-center-cols-container]:!min-h-[initial] [&_.ag-center-cols-container]:!h-[initial] [&_.ag-row]:!h-auto [&_.ag-row-position-absolute]:relative [&_.ag-row]:!bg-[#E9F1FC] [&_.ag-row]:flex [&_.ag-row]:!border-[2px] [&_.ag-row]:!border-transparent [&_.ag-row]:rounded-[13px] [&_.ag-cell]:!border-none [&_.ag-cell]:!relative [&_.ag-row]:!transform-none [&_.ag-row]:mb-2 [&_.ag-row]:cursor-pointer [&_.ag-row.ag-row-focus]:!border-[2px] [&_.ag-row[style*="lightblue"]]:!border-[#4B8AEB] [&_.ag-row.ag-row-focus]:!border-solid [&_.ag-row.ag-row-hover]:before:!hidden'
                // gridOptions={gridOptions}
                columnDefs={getColumnDefs()}
                rowData={getDepartmentRowData(department)}
                // onSelectionChanged={onSelectionChanged}
                domLayout="autoHeight"
                pagination={true}
                getRowHeight={() => 80}
                paginationPageSize={20}
                onGridReady={onGridReady}
                onRowClicked={(event) => handleRowClick(event)}
                getRowStyle={getRowStyle}
                // ref={gridRef}
                ref={(el) => (searchRef.current[index] = el)}
                paginationPageSizeSelector={false}
              />
            </div>
            // )
          ))}
          {/* {staffData?.staffAttendanceDetails.map((department, index) => ( */}
          <div className='noDataFound'>{staffData?.staffs.length == 0 && (<span>No Data Found!</span>)}</div>
        </div>
          {/* <div className='mang-profile'>
            <Row>
              <Col sm={5}>
                <img className="image" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

              </Col>
              <Col sm={19}>
                <p style={{ fontSize: "13px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                <p style={{ fontSize: "10px" }}>Guard | Security</p>
                <p style={{ fontSize: "8px" }}>Contractor | Lakshya Security</p>
              </Col>
            </Row>
          </div>
          <div className='mang-profile mt-2'>
            <Row>
              <Col sm={5}>
                <img className="image" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

              </Col>
              <Col sm={19}>
                <p style={{ fontSize: "13px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                <p style={{ fontSize: "10px" }}>Guard | Security</p>
                <p style={{ fontSize: "8px" }}>Contractor | Lakshya Security</p>
              </Col>
            </Row>
          </div>
          <div className='mang-profile mt-2'>
            <Row>
              <Col sm={5}>
                <img className="image" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

              </Col>
              <Col sm={19}>
                <p style={{ fontSize: "13px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                <p style={{ fontSize: "10px" }}>Guard | Security</p>
                <p style={{ fontSize: "8px" }}>Contractor | Lakshya Security</p>
              </Col>
            </Row>
          </div>
          <div className='mang-profile mt-2'>
            <Row>
              <Col sm={5}>
                <img className="image" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

              </Col>
              <Col sm={19}>
                <p style={{ fontSize: "13px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                <p style={{ fontSize: "10px" }}>Guard | Security</p>
                <p style={{ fontSize: "8px" }}>Contractor | Lakshya Security</p>
              </Col>
            </Row>
          </div>
          <div className='mang-profile mt-2'>
            <Row>
              <Col sm={5}>
                <img className="image" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

              </Col>
              <Col sm={19}>
                <p style={{ fontSize: "13px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                <p style={{ fontSize: "10px" }}>Guard | Security</p>
                <p style={{ fontSize: "8px" }}>Contractor | Lakshya Security</p>
              </Col>
            </Row>
          </div>
          <div className='mang-profile mt-2'>
            <Row>
              <Col sm={5}>
                <img className="image" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

              </Col>
              <Col sm={19}>
                <p style={{ fontSize: "13px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                <p style={{ fontSize: "10px" }}>Guard | Security</p>
                <p style={{ fontSize: "8px" }}>Contractor | Lakshya Security</p>
              </Col>
            </Row>
          </div>
          <div className='mang-profile mt-2'>
            <Row>
              <Col sm={5}>
                <img className="image" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

              </Col>
              <Col sm={19}>
                <p style={{ fontSize: "13px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                <p style={{ fontSize: "10px" }}>Guard | Security</p>
                <p style={{ fontSize: "8px" }}>Contractor | Lakshya Security</p>
              </Col>
            </Row>
          </div> */}
        </Col>
        <Col lg={20}>
        <style>{dynamicStyles}</style>
          <div key={randNumber} className='ml-2 shiftLocationCalendar'>
            {/* <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              headerToolbar={{
                left: '',
                center: '',
                right: ''
              }}
              events={calendarEvents}
              dayMaxEventRows={3}
              aspectRatio={2}
              height="auto"
              eventMinHeight={50}
              editable={false}
              selectable={true}
              selectMirror={true}
              displayEventTime={false}
              nowIndicator
              eventDisplay="block"
              backgroundColor="red"
              firstDay={1}
              eventContent={(event) => {
                return (
                  <div className='flex flex-col'>
                    <span className="event-text">{event.event.title}</span>
                    <span className="event-text">{event.event.extendedProps.description}</span>
                    <span className="event-text">{event.event.extendedProps.company}</span>

                  </div>
                );
              }}
              // dayCellContent={dayCellContent}
              weekNumberCalculation="ISO"
            /> */}
             <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              // initialView="dayGridMonth"
                headerToolbar={{
                  left: '',
                  center:'',
                  right:'prevYear prev title next nextYear'
                }}
                eventClick={handleDateClick}
              
      // dayCellContent={dayCellContent}
              // events={staffCalendarData.length > 0 ? calendarEvents : null}
              events={events}
              datesSet={handleDatesRender}
              dayMaxEventRows={3}
              aspectRatio={2}
              height="auto"
              width="auto"
              eventMinHeight={30}           
              initialDate= {selectedDate}
              editable={false}
              selectable={true}
              selectMirror={true}
              displayEventTime={false}
              nowIndicator
              eventDisplay="block"
              backgroundColor="red"
              firstDay={1}
              eventContent={(event) => {
                return (
                  <div className='flex flex-col'>
                    { event.event.extendedProps?.item?.isWeeklyOff ?
                    ( <div className='wo shoftLocationWo'>W/O</div> )
                  : (
                    <>
                    <span className="leading-none text-base">{capitalizeFirstLetter(event.event.extendedProps?.shiftData?.shiftFullName)}</span>
                    <span className="leading-none my-1 text-[15px]">{formatTimeWithAMPM(event.event.extendedProps?.shiftData?.shiftStartTime) } - {formatTimeWithAMPM(event.event.extendedProps?.shiftData?.shiftEndTime)}</span>
                    <span className="leading-none text-[15px]">{event.event.extendedProps?.locationData?.map((data,index) => {return ( <span key={index}>
        {index > 0 && " "} 
        {capitalizeFirstLetter(data?.locationName2)}
      </span>)})}</span>
                    </>
  
                  )}
                    
                   
                  </div>
                   )}}
              // dayCellContent={dayCellContent}
              weekNumberCalculation="ISO"
            />
          </div>
        </Col>
      </Row>
      <ShiftPlanModel open={shiftPlanVisible} initialData={shiftPlanData} onCancel={hideShiftPlanForm} location={location} shift={fullShiftData}/>

    </div>
  )
}

export default ShiftManagment